import type { LocaleId } from '../locales';
import type { Fill } from '../template';
import { t, type SceneSpec, type VideoBuilder } from './kit';

export const VIDEO_GALLERY_CATEGORIES = [
  'sale',
  'product',
  'fashion',
  'food',
  'realestate',
  'travel',
  'fitness',
  'event',
  'tech',
  'beauty',
  'auto',
  'hiring',
  'holiday',
  'social',
  'motion',
] as const;
export type VideoGalleryCategory = (typeof VIDEO_GALLERY_CATEGORIES)[number];

export type VideoGalleryFormat = 'vertical' | 'portrait' | 'square' | 'wide';

export interface VideoGalleryEntry {
  /** kebab-case, unique. */
  id: string;
  category: VideoGalleryCategory;
  name: Record<LocaleId, string>;
  /** One short line: the editing idea ("Fast beat cuts, bold captions"). */
  description: Record<LocaleId, string>;
  /** The format it is designed for first (others still work). */
  format: VideoGalleryFormat;
}

/** A gallery entry with its storyboard and the layout of its scenes. */
export interface VideoTemplateDef extends VideoGalleryEntry {
  scenes: SceneSpec[];
  /** Place the automatic sound effects (whooshes on transitions, ticks…). */
  sound?: boolean;
  /** Adds the layers, effects and camera moves; returns the document background. */
  build: (b: VideoBuilder) => Fill | null;
}

/** Scene names used by several templates. */
export const SN = {
  hook: t('Hook', 'Гачок', 'Зацепка', 'Haczyk', 'Cârlig', 'Gancho'),
  intro: t('Intro', 'Вступ', 'Вступление', 'Intro', 'Intro', 'Intro'),
  product: t('Product', 'Товар', 'Товар', 'Produkt', 'Produs', 'Producto'),
  offer: t('Offer', 'Пропозиція', 'Предложение', 'Oferta', 'Ofertă', 'Oferta'),
  cta: t('Call to action', 'Заклик', 'Призыв', 'Wezwanie', 'Îndemn', 'Llamada'),
  details: t('Details', 'Деталі', 'Детали', 'Szczegóły', 'Detalii', 'Detalles'),
  benefits: t('Benefits', 'Переваги', 'Преимущества', 'Zalety', 'Beneficii', 'Ventajas'),
};
